import React, { useState } from 'react';
import { ContentSection, Layout, Logo, PageWrap } from '@vwfs-bronson/bronson-react';
import { RegistrationResult } from 'common';
import { Identification } from './identification';
import { SmsIdentification } from './sms-identification';
import { BusinessFormProps, CustomerType, PersonFormProps } from './identification/types';
import { useTranslation } from 'react-i18next';

type ViewTypes = 'REGISTRATION' | 'SMS_CONFIRMATION';

type CustomerRegistration = {
    customerFormData?: PersonFormProps | BusinessFormProps;
    customerType?: CustomerType;
    registrationResult?: RegistrationResult;
};

export const RegistrationUi: React.FC = () => {
    const { t } = useTranslation('registration');
    const [currentView, setCurrentView] = useState<ViewTypes>('REGISTRATION');
    const [customerRegistrationData, setCustomerRegistrationData] = useState<CustomerRegistration>({});

    const onSubmitSuccess = (
        registrationResult: RegistrationResult,
        customerType: CustomerType,
        customerFormData: PersonFormProps | BusinessFormProps,
    ): void => {
        setCustomerRegistrationData({
            customerType,
            registrationResult,
            customerFormData,
        });
        setCurrentView('SMS_CONFIRMATION');
    };

    const { customerType, customerFormData, registrationResult } = customerRegistrationData;

    return (
        <ContentSection>
            <PageWrap size={'xsmall'}>
                <Layout className={'u-mt-large'}>
                    <Layout.Item default={'1/1'}>
                        <Logo style={{ width: 280 }} src={t('logoHeaderUrl')} className={'u-block-center'} />
                    </Layout.Item>
                    {currentView === 'REGISTRATION' && <Identification onSubmitSuccess={onSubmitSuccess} />}
                    {currentView === 'SMS_CONFIRMATION' &&
                        registrationResult?.customerId &&
                        customerType &&
                        customerFormData && (
                            <SmsIdentification
                                customerType={customerType}
                                customerRegistrationResult={registrationResult}
                                customerFormData={customerFormData}
                            />
                        )}
                </Layout>
            </PageWrap>
        </ContentSection>
    );
};
